import { render, staticRenderFns } from "./FormAlignmentLine.vue?vue&type=template&id=4a9f816c&scoped=true&"
import script from "./FormAlignmentLine.vue?vue&type=script&lang=ts&"
export * from "./FormAlignmentLine.vue?vue&type=script&lang=ts&"
import style0 from "./FormAlignmentLine.vue?vue&type=style&index=0&id=4a9f816c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9f816c",
  null
  
)

export default component.exports